var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAboundMarkBottom = function SvgAboundMarkBottom(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10.5033,
    height: 8.03098,
    viewBox: "0 0 10.5033 8.03098",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5033 8.03098H6.07045L5.11047 5.14163H0L0.338816 4.20989L1.02586 2.3464L1.0635 2.25229C1.11056 2.12994 1.14821 2.017 1.19527 1.90406C1.35526 1.51819 1.53408 1.15114 1.74114 0.793498C2.10819 0.144102 2.73876 -0.0253052 3.41639 0.00292941C3.80226 0.0217525 4.19755 0.0970444 4.58342 0.181748C4.79048 0.228806 4.97871 0.275863 5.17635 0.322921L7.98099 1.14173L10.5033 8.03098Z",
    fill: "url(#paint0_linear_0_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_6",
    x1: 6.43059,
    y1: 0.124429,
    x2: 2.73361,
    y2: 9.12632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAboundMarkBottom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/abound-mark-bottom.b8a8c495b936a16e36e2ec1f1cbb0d13.svg";